/**
 * Calculator2 JS controller. (Maatalousyrittäjän Mela-turva)
 *
 * This class handles processing of second calculator form.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class Calculator2. This gets mapped with the keyword Calculator2 and its
 * docready method is fired automatically on pages where there's a
 * class called 'Calculator2' on the html tag.
 */
class Calculator2 {

    /**
     * The class constructor is for binding class properties.
     */
    constructor() {
    }

    /**
     * Cache dom elements for use in the methods
     */
    cache() {

        // Instance of the Calculators utility class.
        this.utils = Theme.getController( 'Calculators' );

        // Store a shorthand reference to translatable strings.
        this.strings = themeData.themeStrings.calculators;

        // Calculator form.
        this.$form = this.utils.initForm( 'maatalousyrittajan-mela-turva' );

    }

    /**
     * All dom events of the class.
     * @return {void}
     */
    events() {

        // Bind a handler to form submit.
        this.$form.on( 'submit', e => this.calculateForm( e ) );

        // Prevent native HTML validation
        this.$form[0].noValidate = true;

        // Auto-submit the form? See Calculators class for details.
        if ( this.$form.data( 'submit' ) ) {
            this.$form.trigger( 'submit' );
        }

    }

    /**
     * Processing function for the form.
     *
     * @param {object} e Event object.
     */
    calculateForm( e ) {

        // Stop propagation
        Theme.Common.stop( e );

        // Placeholder for calculated data.
        this.calculatedData = {
            'rows': {
                'myel_insurance_cost': null,
                'myel_insurance_cost_increased': null,
                'work_mata_insurance_cost': null,
                'work_mata_insurance_health_services_cost': null,
                'leisure_mata_insurance_cost': null,
                'group_life_insurance_cost': null,
                'stand_in_cost': [
                    null,
                    'eur_per_hour'
                ],
                'mela_sickness_benefit': [
                    null,
                    'eur_per_day'
                ],
                'mata_benefit': [
                    null,
                    'eur_per_day'
                ]
            },
            'pension_graph': {
            }
        };

        // Validate and store form values in class property validatedData.
        this.validatedData = this.utils.validateForm( this.$form, {
            'birth_year': 0,            // int >=0
            'birth_month': 0,           // int 1-12
            'insurance_basis': 0,       // int 0-2 (0 = pakollinen MYEL, 1 = vapaaehtoinen MYEL, 2 = vapaaehtoinen työajan MATA)
            'myel_income': 0,           // float >=0 (EUR/year)
            'future_earnings': 0,       // int 0-1 (0 = kasvaa noin 1,5%, 1 = ei muutu)
            'accumulated_pension': 0    // float >=0 (EUR/month)
        });

        // Calculate MYEL insurance cost and the type of it (normal or increased, based on the
        // age calculated from birth year).
        const MYELInsurance = this.utils.calculateMYELInsurance(
            this.validatedData.myel_income,
            this.validatedData.birth_year,
            this.validatedData.birth_month
        );
        this.calculatedData.rows['myel_insurance_cost' + ( MYELInsurance[1] ? '_increased' : '' ) ] = MYELInsurance[0];

        // Calculate work time MATA insurance.
        this.calculatedData.rows['work_mata_insurance_cost'] = this.utils.calculateMATAInsurance(
            this.validatedData.myel_income,
            parseInt( this.validatedData.insurance_basis ),
            1
        )[0];

        // Calculate work time MATA insurance for members of health services.
        this.calculatedData.rows['work_mata_insurance_health_services_cost'] = this.utils.calculateMATAInsurance(
            this.validatedData.myel_income,
            parseInt( this.validatedData.insurance_basis ),
            2
        )[0];

        let insuranceRequired = true;

        if ( parseInt( this.validatedData.insurance_basis ) > 0 ) {
            insuranceRequired = false;
        }

        // Calculate leisure time MATA insurance.
        this.calculatedData.rows['leisure_mata_insurance_cost'] = this.utils.calculateLeisureMATAInsurance(
            this.validatedData.myel_income,
            insuranceRequired
        )[0];

        // Group life insurance cost.
        this.calculatedData.rows['group_life_insurance_cost'] = this.utils.groupLifeInsuranceCostEnterpreneurs;

        // Calculate stand-in cost.
        this.calculatedData.rows['stand_in_cost'][0] = this.utils.calculateStandInCost( this.validatedData.myel_income );

        // Calculate MELA sickness benefit.
        this.calculatedData.rows['mela_sickness_benefit'][0] = this.utils.calculateMELASicknessBenefit( this.validatedData.myel_income );

        // Calculate MATA benefit per day.
        this.calculatedData.rows['mata_benefit'][0] = this.utils.calculateMATABenefit(
            this.validatedData.myel_income,
            insuranceRequired
        );

        let pensionIndex = true;

        if ( parseInt( this.validatedData.future_earnings ) === 1 ) {
            pensionIndex = false;
        }

        // Calculate pension.
        this.calculatedData['pension_graph'] = this.utils.calculatePension(
            this.validatedData.myel_income,
            0,
            this.validatedData.accumulated_pension,
            this.validatedData.birth_year,
            this.validatedData.birth_month,
            pensionIndex
        );

        // Additional notes.
        if ( this.validatedData.myel_income <= this.utils.yearlyMinIncome && insuranceRequired ) {
            this.utils.dataNotes[ 'leisure_mata_insurance_cost' ] = this.strings.calculator_note_1;
            this.utils.dataNotes[ 'mata_benefit' ] = this.strings.calculator_note_1;
        }

        // Render output.
        this.outputForm();

    }

    /**
     * Render output for the first form.
     */
    outputForm() {

        // Stop here if errors were found.
        if ( this.utils.validator.errorLog.length ) {
            this.utils.outputErrors( this.$form );
            return false;
        }

        // Create container for output.
        const $container = this.utils.renderResultsContainer( this.$form );

        // Add calculation parameters.
        const $params = this.utils.renderParams(
            this.$form,
            this.validatedData,
            {
                'birth_month': {
                    'value': this.strings[ this.validatedData.birth_month ]
                },
                'myel_income': {
                    'ext': 'eur_per_year'
                },
                'accumulated_pension': {
                    'ext': 'eur_per_month'
                }
            }
        );
        $params.appendTo( $container );

        const insuranceBasis = parseInt( this.validatedData.insurance_basis );

        let rowsToRemove = [];

        // Remove some rows from results table if 'vapaaehtoinen MYEL' is selected.
        if ( insuranceBasis === 1 ) {
            rowsToRemove = [
                'group_life_insurance_cost'
            ];
        }

        // Remove some rows from results table if 'vapaaehtoinen työajan MATA' is selected.
        if ( insuranceBasis === 2 ) {
            rowsToRemove = [
                'myel_insurance_cost',
                'myel_insurance_cost_increased',
                'work_mata_insurance_health_services_cost',
                'group_life_insurance_cost',
                'stand_in_cost',
                'mela_sickness_benefit'
            ];
        }

        // Add results table. Use 2 decimal places for numeric values.
        const $table = this.utils.renderData( this.calculatedData.rows, 2, rowsToRemove );
        $table.appendTo( $container );

        // Add pension graph if 'vapaaehtoinen työajan MATA' is not selected.
        if ( insuranceBasis !== 2 ) {

            const $graphTable = this.utils.renderGraphTable( this.calculatedData['pension_graph'].data, this.strings.estimate_pension_relation_earnings_level );

            // We do not want pension ratio to show in the chart, but we need it in graph table.
            for ( let [ key, value ] of Object.entries( this.calculatedData['pension_graph'].data ) ) {
                delete value.pensionRatio;
            }

            const $chart = this.utils.renderChart(
                this.calculatedData['pension_graph'].data,
                this.strings.estimated_monthly_pension_heading
            );

            $chart.appendTo( $container );
            $graphTable.appendTo( $container );

           if ( this.calculatedData['pension_graph'].info ) {

                // Add info texts.
                const $info = this.utils.renderInfo( this.calculatedData['pension_graph'].info, '<br><br>' );
                $info.appendTo( $container );
            }
        }

        // Append action buttons.
        const $buttons = this.utils.renderButtons( this.$form );
        $buttons.appendTo( $container );

        // Add extra content.
        this.utils.renderExtra( this.$form, $container );
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        if ( this.$form && this.$form.length ) {
            this.events();
        }
    }

}

// Export the class reference.
module.exports = Calculator2;



// WEBPACK FOOTER //
// ./assets/scripts/calculator2.js